import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { financeHomeRoute, HttpStatus } from 'config/Api.Config';
import useContractRefundPaymentItem from './Finance.ContractRefundPaymentItem.Hooks';
import FinanceContractRefundPaymentItemExclude from './sections/Finance.ContractRefundPaymentItem.Exclude';
import CreateContractRefundPaymentFromItems from './sections/Finance.ContractRefundPaymentItem.AddPayment';
import ContractRefundPaymentItemList from './sections/Finance.ContractRefundPaymentItem.List';

export const financeContractRefundPaymentItemIndexRoute = financeHomeRoute + '/contractRefundPaymentItem/:action?/:id?';
export default function FinanceContractRefundPaymentItemIndex() {
  const contractRefundPaymentItemHook = useContractRefundPaymentItem();

  if (!contractRefundPaymentItemHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={contractRefundPaymentItemHook}
        render={({ views }) => (
          <>
            {views.createPayment && <CreateContractRefundPaymentFromItems />}
            <ContractRefundPaymentItemList />
            {views.exclude && <FinanceContractRefundPaymentItemExclude />}
          </>
        )}
      />
    </>
  );
}
